import PropTypes from 'prop-types';

// material-ui
import { Box, Container, Grid, Rating, Typography } from '@mui/material';

// third party
import Slider from 'react-slick';

// project import
import MainCard from '../../Components/MainCard';

const Feature = ({ feature }) => (
  <MainCard sx={{ mx: 2 }} contentSX={{ p: 3 }}>
    <Grid container spacing={1}>
      {/*<Grid item>*/}
      {/*  <Avatar src={feature.image} alt="feature" />*/}
      {/*</Grid>*/}
      <Grid item sm zeroMinWidth>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              {feature.title}
            </Typography>
            {/*<Rating name="read-only" readOnly value={feature.rating} size="small" precision={0.5} />*/}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" color="grey">
              {feature.description}
            </Typography>
          </Grid>
          {/*<Grid item xs={12}>*/}
          {/*  <Typography variant="subtitle2">{feature.client}</Typography>*/}
          {/*</Grid>*/}
        </Grid>
      </Grid>
    </Grid>
  </MainCard>
);

Feature.propTypes = {
  feature: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  })
};
const Roadmap = () => {
    const settings = {
        autoplay: true,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        rtl: true
      };

    const features = [
    {
      title: 'Dashboard Analytics Increased Features',
      description:
        'Visually inspect the financial wellbeing of your business. Utilise these insights to make data informed decisions.'
    },
    {
      title: 'Submit a feature request',
      description:
        "If you would like to see a feature available in Ikigai please let the team know. We are always aiming to improve Ikigai."
    }
  ];

    return (
    <Box sx={{ overflowX: 'hidden' }}>
      <Container>
          <Grid item xs={12}>
            <Grid container spacing={1} justifyContent="center" sx={{ mb: 4, textAlign: 'center' }}>
              <Grid item sm={10} md={6}>
                <Grid container spacing={1} justifyContent="center">
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" color="primary">
                      Roadmap
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h2">Upcoming Release</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1">
                      Below are features coming to Ikigai
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        <Grid container alignItems="center" justifyContent="center" spacing={2} sx={{ mt: { md: 15, xs: 2.5 }, mb: { md: 10, xs: 2.5 } }}>
          <Grid item lg={6} md={8} xs={12} sx={{ '& .slick-list': { overflow: 'visible' } }}>
            <Slider {...settings}>
              {features.map((feature, index) => (
                <Feature key={index} feature={feature} />
              ))}
            </Slider>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );

}

export default Roadmap;